// Mapping for employment industry
export const industryToEmploymentIndustryMap: Record<string, string> = {
  "Energy Equipment & Services": "Mining/Oil and Gas/Energy",
  "Oil, Gas & Consumable Fuels": "Mining/Oil and Gas/Energy",
  Chemicals: "Science",
  "Construction Materials": "Construction",
  "Containers & Packaging": "Agriculture/Manufacturing",
  "Metals & Mining": "Mining/Oil and Gas/Energy",
  "Paper & Forest Products": "Agriculture/Manufacturing",
  "Aerospace & Defense": "Military/Law Enforcement",
  "Building Products": "Construction",
  "Construction & Engineering": "Construction",
  "Electrical Equipment": "Agriculture/Manufacturing",
  "Industrial Conglomerates": "Agriculture/Manufacturing",
  Machinery: "Agriculture/Manufacturing",
  "Trading Companies & Distributors": "Retail/Sales",
  "Commercial Services & Supplies": "Administration/Clerical/Facilities Svc",
  "Professional Services": "Administration/Clerical/Facilities Svc",
  "Air Freight & Logistics": "Transportation/Shipping",
  "Passenger Airlines": "Tourism/Airlines/Maritime",
  "Marine Transportation": "Transportation/Shipping",
  "Ground Transportation": "Transportation/Shipping",
  "Transportation Infrastructure": "Transportation/Shipping",
  "Automobile Components": "Automotive Repairs and Sales",
  Automobiles: "Automotive Repairs and Sales",
  "Household Durables": "Retail/Sales",
  "Leisure Products": "Retail/Sales",
  "Textiles, Apparel & Luxury Goods": "Retail/Sales",
  "Hotels, Restaurants & Leisure": "Hotel/Restaurant",
  "Diversified Consumer Services": "Retail/Sales",
  Distributors: "Retail/Sales",
  "Broadline Retail": "Retail/Sales",
  "Specialty Retail": "Retail/Sales",
  "Consumer Staples Distribution & Retail": "Retail/Sales",
  Beverages: "Retail/Sales",
  "Food Products": "Retail/Sales",
  Tobacco: "Retail/Sales",
  "Household Products": "Retail/Sales",
  "Personal Care Products": "Retail/Sales",
  "Health Care Equipment & Supplies": "Medical & Health",
  "Health Care Providers & Services": "Medical & Health",
  "Health Care Technology": "Medical & Health",
  Biotechnology: "Medical & Health",
  Pharmaceuticals: "Medical & Health",
  "Life Sciences Tools & Services": "Medical & Health",
  Banks: "Banking/Finance/Insurance",
  "Financial Services": "Banking/Finance/Insurance",
  "Consumer Finance": "Banking/Finance/Insurance",
  "Capital Markets": "Banking/Finance/Insurance",
  "Mortgage Real Estate Investment Trusts (REITs)": "Banking/Finance/Insurance",
  Insurance: "Banking/Finance/Insurance",
  "IT Services": "Information Technology",
  Software: "Information Technology",
  "Communications Equipment": "Advertising/Media/Communications",
  "Technology Hardware, Storage & Peripherals": "Agriculture/Manufacturing",
  "Electronic Equipment, Instruments & Components": "Agriculture/Manufacturing",
  "Semiconductors & Semiconductor Equipment": "Agriculture/Manufacturing",
  "Diversified Telecommunication Services": "Advertising/Media/Communications",
  "Wireless Telecommunication Services": "Advertising/Media/Communications",
  Media: "Advertising/Media/Communications",
  Entertainment: "Arts/Entertainment and Recreation",
  "Interactive Media & Services": "Advertising/Media/Communications",
  "Electric Utilities": "Water/Utilities/Waste Management",
  "Gas Utilities": "Water/Utilities/Waste Management",
  "Multi-Utilities": "Water/Utilities/Waste Management",
  "Water Utilities": "Water/Utilities/Waste Management",
  "Independent Power and Renewable Electricity Producers":
    "Water/Utilities/Waste Management",
  "Diversified REITs": "Banking/Finance/Insurance",
  "Industrial REITs": "Banking/Finance/Insurance",
  "Hotel & Resort REITs": "Banking/Finance/Insurance",
  "Office REITs": "Banking/Finance/Insurance",
  "Health Care REITs": "Banking/Finance/Insurance",
  "Residential REITs": "Banking/Finance/Insurance",
  "Retail REITs": "Banking/Finance/Insurance",
  "Specialized REITs": "Banking/Finance/Insurance",
  "Real Estate Management & Development": "Real Estate/Property",
};

//Mapping for business type
export const industryToBusinessTypeMap: Record<string, string> = {
  "Energy Equipment & Services": "Oil and Gas",
  "Oil, Gas & Consumable Fuels": "Oil and Gas",
  Chemicals: "Manufacturing",
  "Construction Materials": "Construction & Engineering",
  "Containers & Packaging": "Manufacturing",
  "Metals & Mining": "Extractive industries",
  "Paper & Forest Products": "Forestry and Logging",
  "Aerospace & Defense": "Modern Weaponry Businesses / Companies",
  "Building Products": "Construction & Engineering",
  "Construction & Engineering": "Construction & Engineering",
  "Electrical Equipment": "Manufacturing",
  "Industrial Conglomerates": "Manufacturing",
  Machinery: "Manufacturing",
  "Trading Companies & Distributors":
    "Wholesale Trading Associated with Non-High-Risk Products (e.g., Agriculture, Food, etc)",
  "Commercial Services & Supplies": "Professional Service Providers",
  "Professional Services": "Professional Service Providers",
  "Air Freight & Logistics": "Logistics, Transportation and Storage",
  "Passenger Airlines": "Logistics, Transportation and Storage",
  "Marine Transportation": "Maritime / Shipping",
  "Ground Transportation": "Logistics, Transportation and Storage",
  "Transportation Infrastructure": "Logistics, Transportation and Storage",
  "Automobile Components": "Automobile, Boat and Plane Dealerships",
  Automobiles: "Automobile, Boat and Plane Dealerships",
  "Household Durables": "Retail shops associated with Non-High Risk Products",
  "Leisure Products": "Sports and Recreation",
  "Textiles, Apparel & Luxury Goods": "Luxury Goods",
  "Hotels, Restaurants & Leisure": "Entertainment",
  "Diversified Consumer Services": "Professional Service Providers",
  Distributors:
    "Wholesale Trading Associated with Non-High-Risk Products (e.g., Agriculture, Food, etc)",
  "Broadline Retail": "Retail shops associated with Non-High Risk Products",
  "Specialty Retail": "Retail shops associated with Non-High Risk Products",
  "Consumer Staples Distribution & Retail":
    "Retail shops associated with Non-High Risk Products",
  Beverages: "Food and Beverages",
  "Food Products": "Food Production",
  Tobacco: "Tobacco",
  "Household Products": "Retail shops associated with Non-High Risk Products",
  "Personal Care Products":
    "Retail shops associated with Non-High Risk Products",
  "Health Care Equipment & Supplies": "Medical, Healthcare and Social Services",
  "Health Care Providers & Services": "Medical, Healthcare and Social Services",
  "Health Care Technology": "Medical, Healthcare and Social Services",
  Biotechnology: "Medical, Healthcare and Social Services",
  Pharmaceuticals: "Medical, Healthcare and Social Services",
  "Life Sciences Tools & Services": "Medical, Healthcare and Social Services",
  Banks: "Banks (Entities licensed in FATF members jurisdictions)",
  "Financial Services":
    "Finance Companies (Entities licensed in FATF members jurisdictions)",
  "Consumer Finance":
    "Finance Companies (Entities licensed in FATF members jurisdictions)",
  "Capital Markets":
    "Capital Market Services (Entities licensed in FATF members jurisdictions)",
  "Mortgage Real Estate Investment Trusts (REITs)":
    "Trust and Corporate Service Providers",
  Insurance:
    "Insurance / Insurers (Entities licensed in FATF members jurisdictions)",
  "IT Services": "Information Technology/IT",
  Software: "Software Technology and Application",
  "Communications Equipment": "Telecommunications",
  "Technology Hardware, Storage & Peripherals": "Manufacturing",
  "Electronic Equipment, Instruments & Components": "Manufacturing",
  "Semiconductors & Semiconductor Equipment": "Manufacturing",
  "Diversified Telecommunication Services": "Telecommunications",
  "Wireless Telecommunication Services": "Telecommunications",
  Media: "Media and Communications",
  Entertainment: "Entertainment",
  "Interactive Media & Services": "Media and Communications",
  "Electric Utilities": "Utilities",
  "Gas Utilities": "Utilities",
  "Multi-Utilities": "Utilities",
  "Water Utilities": "Utilities",
  "Independent Power and Renewable Electricity Producers": "Utilities",
  "Diversified REITs": "Trust and Corporate Service Providers",
  "Industrial REITs": "Trust and Corporate Service Providers",
  "Hotel & Resort REITs": "Trust and Corporate Service Providers",
  "Office REITs": "Trust and Corporate Service Providers",
  "Health Care REITs": "Trust and Corporate Service Providers",
  "Residential REITs": "Trust and Corporate Service Providers",
  "Retail REITs": "Trust and Corporate Service Providers",
  "Specialized REITs": "Trust and Corporate Service Providers",
  "Real Estate Management & Development": "Real Estate (Property Developers)",
};

// Mapping for entity type
export const entityTypeMap: Record<string, string> = {
  "Association or Nonprofit Organization": "clubs_associations_societies",
  Cooperative: "clubs_associations_societies",
  "Corporation (Inc. or Ltd.)": "limited_liability_company",
  Foundation: "trust_or_other_similar_arrangements",
  "Licensed Fund": "variables_capital_companies",
  "Limited Liability Company (LLC)": "limited_liability_company",
  "Limited Liability Partnership (LLP)": "limited_liability_partnership",
  "Limited Partnership (LP)": "limited_partnership",
  "Pte Ltd": "private_limited_companies",
  "Real Estate Investment Trust (REIT)": "trust_or_other_similar_arrangements",
  "Sovereign Wealth Fund":
    "public_sector_bodies_government_entities_state-owned_entities_and_supranationals",
  Trust: "trust_or_other_similar_arrangements",
  Others: "-",
};

// Maps FH industry to Wallex business type
export const mapIndustryToBusinessType = (
  industry: string | undefined
): string => {
  // Handle undefined or empty string
  if (!industry) return "-";

  // Direct lookup in map, with fallback to industry name or "-"
  return industryToBusinessTypeMap[industry] || industry || "-";
};

// Maps FH entity type to Wallex entity type format
export const mapEntityType = (entityType: string | undefined): string => {
  // Handle undefined or empty string
  if (!entityType) return "-";

  // Direct lookup in map, with fallback to "-"
  return entityTypeMap[entityType] || entityType || "-";
};

// Maps FH industry to Wallex employment industry
export const mapIndustryToEmploymentIndustry = (
  industry: string | undefined
): string => {
  // Handle undefined or empty string
  if (!industry) return "-";

  // Direct lookup in map, with fallback to industry name or "-"
  return industryToEmploymentIndustryMap[industry] || industry || "-";
};
